export default {
  banner: {
    title: "Connect every person and app on the planet",
    subtitle:
      "Authing quickly implements authentication and user management for any Web, App, and enterprise software to provide the most complete login solution for your customers and employees.",
  },
  twoThing: {
    title: "We do two things for you",
    subtitle:
      "We also have internal and external identity management platform to provide the most suitable products for your enterprise",
    "item-one": {
      title: "Customer Identity",
      subtitle:
        "Five lines of code to create a secure and seamless authentication experience for your customers",
      "list-one": "Third-Party Login",
      "list-two": "Mobile Number Verification",
      "list-three": "Multi-Factor Authentication",
      "list-four": "Single Sign-On",
      "list-five": "Universal Login",
      "list-six": "Customized Certification Process",
    },
    "item-two": {
      title: "Workforce Identity",
      subtitle:
        "No development, integrated with internal systems, unified control of employee application identity rights and privileges",
      "list-one": "Single Sign-On",
      "list-two": "Multi-Factor Authentication",
      "list-three": "Support Privatization Deployment",
      "list-four": "Authority Management",
      "list-five": "Num Verification",
    },
  },
  advantage: {
    title: "Authing Advantages",
    subtitle: "Authing makes identity management simple",
    "number-unit": "w",
    "item-one": {
      title: "Reduce development costs",
      descript:
        "Using Authing identity center ensures the health of the organization and users. Whether replacing a self-developed solution or a vendor, using Authing is a good choice for your organization.",
    },
    "item-two": {
      title: "Login Security",
      descript:
        "Encrypted storage and transmission via asymmetrically encrypted RSA and key infrastructure KMS to ensure that only the user can access all raw data. Authing supports custom password strength and password encryption algorithms, multiple anti-burst, malicious registration mechanisms.",
    },
    "item-three": {
      title: "Number of secure logins per month",
      descript:
        "The use of Authing ensures maximum decoupling of the system, making it easy to combine with Serverless or with existing services.",
    },
  },
  IAM: {
    title: "Build a modern user center for you",
    subtitle:
      "Authing identity cloud can help enterprises manage external user accounts and internal employee permissions safely and efficiently, and ensure that enterprises focus on core business",
    "item-one": {
      title: "Single Sign-On",
      subtitle:
        "Log in once and use all applications that you have been granted access to.",
    },
    "item-two": {
      title: "Login component",
      subtitle:
        "With just a few lines of code, the registration login form is generated immediately. You can also use the Authing SDK to customize the form.",
    },
    "item-tree": {
      title: "Multi factor certification",
      subtitle:
        "Authing multi factor authentication support and other login authentication methods.",
    },
    "item-four": {
      title: "User management",
      subtitle:
        "Authing dashboard integrates the functions of user information, authority, data analysis and management, so that you can complete user authentication one-stop.",
    },
  },
  industry: {
    title: "Industry Solutions",
    subtitle:
      "We provide professional solutions for different industries and application areas to improve the productivity of enterprises",
    "item-one": {
      title: "Government",
      descript:
        "Citizens access all systems with one account and log in to government services safely.",
    },
    "item-two": {
      title: "Publisher",
      descript:
        "Readers focus on reading, hundreds of millions of users in the fingers of the expansion, distribution, author, editor, all in control.",
    },
    "item-tree": {
      title: "Finance",
      descript:
        "Enabling financial cloud, intuitive and visual analysis platform, in line with national regulatory standards.",
    },
    "item-four": {
      title: "Game",
      descript:
        "Players come in quickly, let hackers away from the point, multi identity source login quickly, ensure that users access sensitive information.",
    },
  },
  code: {
    title: "Five-lines of code will embed login into any application",
    subtitle:
      "Just drink a cup of coffee, you can have a secure and powerful identity module",
    other: "Supports any technology stack",
  },
  news: {
    title: "News",
  },
  other: {
    title: "Customer Evaluation",
    "item-one": {
      common:
        "“Authing is very innovative in emerging technologies such as cloud authentication, single sign-on, and serverless computing.”",
      author: "Southeast University",
    },
    "item-two": {
      common: "“Authing does a great job and integrates very well.”",
      author: "AWS（Amazon Cloud Computing Service）",
    },
    "item-three": {
      common:
        "“Compared with many manufacturers, we can feel the advantages of Authing. This is a product made through thinking.”",
      author: "Higher Education Press",
    },
    "item-four": {
      common: "“Authing offers everything one expects and beyond.”",
      author: "Zhijiang Lab",
    },
    "item-five": {
      common:
        "“After trying numerous Global solutions, Authing is the most professional one.”",
      author: "K-Trust Technology",
    },
    "item-six": {
      common:
        "“Authing's Customer Success Teams are always fast in responding.”",
      author: "Toyota",
    },
    "item-seven": {
      common:
        "“Any time whenever we have required Authing, Authing's CS Teams is always responsive. Sometimes I just checked Beijing time and found that it is already another day, but they are still in work. I really appreciate this. Hats off to Authing.”",
      author: "JCDecaux Group",
    },
    "item-eight": {
      common:
        "“Hi, our team in China is using your product, they seem to be happy about the product and service!”",
      author: "Wei-Liang Kao · Co-Founder at Deephow",
    },
    "customer-detail": "Read customer success stories",
    "customer-detail-default": "Detailed cases are on the way",
    "title-cooperatner": "Cooperative partner",
    brand: {
      "item-one": "ISO 9001",
      "item-two": "General Data Protection Regulation",
      "item-tree": "White paper on Chinese network security",
      "item-four": "DJCP Level 3",
      "item-five": "National High Tech Enterprises",
    },
    slogn:
      "Just one step to complete the registration, enjoy 3000 free authentication times.",
  },
  applicationGateway: {
    title: "Application Integration Gateway",
    subtitle:
      "Extend modern identity to native applications to protect your hybrid cloud",
  },
};
